export default __webpack_public_path__ + "static/media/microphone.01819c72.svg";